import ReportTable from './ReportTable'

export default ReportTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/ReportTable/index.js